import { useEffect, useState } from 'react';
import { ApiError } from '../../../shared/shared.api';
import { getRateCard, type RateCardView } from '../rate-cards.api';

export type RateCardRecordState =
  { status: 'loading' } | { status: 'loaded'; card: RateCardView } | { status: 'forbidden' } | { status: 'not_found' } | { status: 'error' };

function toErrorState(err: unknown): RateCardRecordState {
  if (err instanceof ApiError && err.status === 403) return { status: 'forbidden' };
  if (err instanceof ApiError && err.status === 404) return { status: 'not_found' };
  return { status: 'error' };
}

/** One rate card, fetched by id and re-fetchable after a mutation commits. */
export function useRateCardRecord(id: string) {
  const [state, setState] = useState<RateCardRecordState>({ status: 'loading' });

  useEffect(() => {
    let cancelled = false;

    getRateCard(id)
      .then((card) => {
        if (!cancelled) setState({ status: 'loaded', card });
      })
      .catch((err) => {
        if (!cancelled) setState(toErrorState(err));
      });

    return () => {
      cancelled = true;
    };
  }, [id]);

  async function reload(): Promise<void> {
    try {
      setState({ status: 'loaded', card: await getRateCard(id) });
    } catch (err) {
      setState(toErrorState(err));
    }
  }

  return { state, reload };
}
